<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">school</mat-icon>
    <span class="section-title">update tutorials</span>
    <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form [formGroup]="tutorialForm" class="tutorial-form">
        <textarea class="tutorial-textarea"
                  formControlName="content" 
                  placeholder=""></textarea>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!tutorialForm.valid || isSubmitting">
        <span *ngIf="!isSubmitting">OK</span>
        <span *ngIf="isSubmitting">Updating...</span>
    </button>
</mat-dialog-actions>